import { useContext } from 'react'

import { CaptchaContext } from '@percent/education-hosted-form/context/captcha/CaptchaContext'

export const useCaptcha = () => useContext(CaptchaContext)
